import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Pencil = function Pencil(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.801 4.754a.68.68 0 000-.96L12.21 2.198a.676.676 0 00-.959 0L10 3.446 12.55 6l1.25-1.246zM2 11.47V14h2.532L12 6.53 9.468 4 2 11.47z",
    fill: "currentColor"
  }));
};
export default Pencil;